import React, { ReactElement, useEffect, useState } from 'react'
import verificationStore from '../../../../../stores/verificaton.store'
import { CreditCardIcon, IdentificationIcon } from '@heroicons/react/24/solid'
import { LIVENESS_STEP } from '../IdAndLiveness'
import VerificationStepConfigEntity from '../../../../../dto/VerificationStepConfigEntity.interface'
import { IdDocType } from '../../../../../enums/IdDocType'
import configStore from '../../../../../stores/config.store'
import Loader from '../../../../loader/Loader'

const docTypes = [
  {
    key: IdDocType.PASSPORT,
    restrictionKey: 'passports',
    label: 'Passport',
    icon: <IdentificationIcon className="w-4 m-1" />
  },
  {
    key: IdDocType.ID_CARD,
    restrictionKey: 'idCards',
    label: 'ID Card',
    icon: <CreditCardIcon className="w-4 m-1" />
  }
]

interface Props {
  setCurrentStep: (step: LIVENESS_STEP) => void
  verificationStepsConfig?: VerificationStepConfigEntity
}

const DocumentSelect = ({
  setCurrentStep,
  verificationStepsConfig
}: Props): ReactElement => {
  // const methods = useForm<any>({ mode: 'onSubmit' })
  const [documentRestriction, setDocumentRestriction] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  // const [selectedDocType, setSelectedDocType] = useState<
  //   IdDocType | undefined
  // >()

  useEffect(() => {
    if (verificationStepsConfig?.idAndLiveness) {
      setDocumentRestriction(
        verificationStepsConfig.idAndLiveness.documentRestriction
      )
    }
  }, [verificationStepsConfig])

  const save = async (args: {
    selectedDocumentType: string
    selectedDocumentCountry?: string
  }): Promise<void> => {
    setIsLoading(true)
    await verificationStore
      .saveIdAndLivenessInformation(args)
      .catch((err) => console.log(err))
    setIsLoading(false)
    if (
      verificationStore.idAndLiveness &&
      verificationStore.idAndLiveness.documentsUploaded
    ) {
      setCurrentStep(LIVENESS_STEP.LIVENESS)
    } else {
      setCurrentStep(LIVENESS_STEP.DOCUMENT)
    }
  }

  const renderDocRestriction = (): ReactElement => {
    if (!documentRestriction) {
      return <></>
    }
    return (
      <div className="w-full">
        {Object.keys(documentRestriction).map((key) => {
          const element = docTypes.find(
            (element: any) => element.restrictionKey === key
          )

          if (!element) {
            return <></>
          }

          return (
            <div
              id={`btn-${key}`}
              key={key}
              className="flex flex-row items-center rounded-lg cursor-pointer border hover:border-primary mb-4 shadow"
              onClick={() => {
                // if (hasIdDocTypeLngSelection(element.key)) {
                //   setSelectedDocType(element.key)
                // } else {
                save({ selectedDocumentType: element.key }).catch((err) =>
                  console.log(err)
                )
                // }
              }}
            >
              <div className="m-2 bg-gray-200 dark:bg-primary rounded">
                {element.icon}
              </div>
              <div className="ml-2">{element.label}</div>
            </div>
          )
        })}
      </div>
    )
  }

  // const renderLngSelection = (): ReactElement => {
  //   return (
  //     <FormProvider {...methods}>
  //       <CountryDropdownSelected
  //         variable="idCardCountry"
  //         title="ID Card Country"
  //         hideTitle={true}
  //         onSelect={(option) => {
  //           if (selectedDocType && option.value) {
  //             save({
  //               selectedDocumentType: selectedDocType,
  //               selectedDocumentCountry: option.value
  //             }).catch((err) => console.log(err))
  //           }
  //         }}
  //         options={getValidIdCountries()}
  //         required={true}
  //       />
  //     </FormProvider>
  //   )
  // }

  return (
    <div>
      <div className="w-full">
        {isLoading ? (
          <div className="h-full flex justify-center items-center mt-10">
            <Loader color={configStore.config?.primaryColor} />
          </div>
        ) : (
          // ) : selectedDocType && hasIdDocTypeLngSelection(selectedDocType) ? (
          //   renderLngSelection()
          renderDocRestriction()
        )}
      </div>
    </div>
  )
}

export default DocumentSelect
